import { render } from "./TheAdminResourcesList.vue?vue&type=template&id=a1eb6022&ts=true"
import script from "./TheAdminResourcesList.vue?vue&type=script&lang=ts"
export * from "./TheAdminResourcesList.vue?vue&type=script&lang=ts"

import "./TheAdminResourcesList.vue?vue&type=style&index=0&id=a1eb6022&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__